'use client'

import { Link, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button"
import { Mic, Globe, Linkedin, Instagram, Youtube, Twitter } from 'lucide-react'
import { useEffect, useState } from "react"

export default function Component() {
  const location = useLocation();
  
  const [isVideoPlaying, setIsVideoPlaying] = useState(false)

  return (
    <div className="min-h-screen bg-black text-white">


      <main>
       
        <section className="min-h-screen flex items-center justify-center">
          <div className="container mx-auto px-4 py-32 text-center">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-tight mb-12 [text-wrap:balance]">
              Do you take pauses
              <br />
              while speaking?
            </h1>
            <Link 
              to="/auth"
              className="inline-flex items-center justify-center px-8 py-3 text-sm rounded-full bg-black border border-gray-800 text-gray-300 hover:text-white hover:border-gray-700 transition-colors shadow-[0_0_15px_rgba(59,130,246,0.5)] hover:shadow-[0_0_30px_rgba(59,130,246,0.5)]"
            >
              Explore products
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="ml-2 h-4 w-4"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </Link>
             {/* <div className="mt-8">
      <a 
        href="https://www.producthunt.com/posts/speakclearlyai?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-speakclearlyai" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img 
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=833048&theme=light&t=1738218482436" 
          alt="SpeakclearlyAI - AI-POWERED FILLER WORD REMOVAL & BACKGROUND NOISE CLEANUP | Product Hunt" 
          style={{ width: "250px", height: "54px" }} 
          width="250" 
          height="54" 
        />
      </a>
    </div> */}
          </div>
        </section>

        
        <section className="min-h-screen flex items-center">
          <div className="container mx-auto px-4">
            <div className="space-y-8">
              <p className="text-gray-400">Introducing our first product</p>
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-normal tracking-tight">
                A browser extension for
                <br />
                clear communication
              </h2>
            </div>
          </div>
        </section>

        
        <section id = "features" className="min-h-screen py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-20 items-center">
              <div className="space-y-8">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-normal tracking-tight hover:text-blue-400 transition-colors">
                  Remove any Background Noise
                </h2>
                <p className="text-gray-400 text-xl hover:text-white transition-colors">
                  Watch how our AI removes Background Noise in real-time
                </p>
              </div>
              <div className="relative aspect-video">
                <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full" />
                <video
  className="relative rounded-2xl border border-gray-800 w-full h-full object-cover shadow-lg"
  loop
  autoPlay
  muted
  playsInline
  ref={(video) => {
    if (video) {
      video.play().catch(error => console.log("Video autoplay failed:", error))
    }
  }}
>
                  <source src="https://dsbeilj7v7pwo.cloudfront.net/hj.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </section>

        
        <section className="min-h-screen py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-20 items-center">
              <div className="space-y-8">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-normal tracking-tight hover:text-blue-400 transition-colors">
                  Remove Filler words
                </h2>
                <p className="text-gray-400 text-xl hover:text-white transition-colors">
                  Set your preferences and let AI handle the rest
                </p>
              </div>
              <div className="relative">
                <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full" />
                <video
  className="relative rounded-2xl border border-gray-800 w-full h-full object-cover shadow-lg"
  loop
  autoPlay
  muted
  playsInline
  ref={(video) => {
    if (video) {
      video.play().catch(error => console.log("Video autoplay failed:", error))
    }
  }}
>
                  <source src="https://dsbeilj7v7pwo.cloudfront.net/v2.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </section>

        
        <section className="min-h-screen py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-20 items-center">
              <div className="relative order-2 md:order-1">
                <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full" />
                <video
  className="relative rounded-2xl border border-gray-800 w-full h-full object-cover shadow-lg"
  loop
  autoPlay
  muted
  playsInline
  ref={(video) => {
    if (video) {
      video.play().catch(error => console.log("Video autoplay failed:", error))
    }
  }}
>
                  <source src="https://dsbeilj7v7pwo.cloudfront.net/tts.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="space-y-8 order-1 md:order-2">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-normal tracking-tight hover:text-blue-400 transition-colors">
                  Human-like Text-to-Speech
                </h2>
                <p className="text-gray-400 text-xl hover:text-white transition-colors">
                Deliver natural, expressive, and engaging voices for every application
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Additional Feature: AI-powered Suggestions */}
        <section className="min-h-screen py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-20 items-center">
              <div className="space-y-8">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-normal tracking-tight hover:text-blue-400 transition-colors">
                  Deploy AI-Agents
                </h2>
                <p className="text-gray-400 text-xl hover:text-white transition-colors">
                  Receive personalized tips to improve your communication
                </p>
              </div>
              <div className="relative">
                <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full" />
                <video
  className="relative rounded-2xl border border-gray-800 w-full h-full object-cover shadow-lg"
  loop
  autoPlay
  muted
  playsInline
  ref={(video) => {
    if (video) {
      video.play().catch(error => console.log("Video autoplay failed:", error))
    }
  }}
>
                  <source src="https://dsbeilj7v7pwo.cloudfront.net/v3.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </section>

        {/* Privacy Section */}
        <section className="min-h-screen py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-20 items-center">
              <div className="relative order-2 md:order-1">
                <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full" />
                <div className="relative aspect-square bg-gradient-to-br from-blue-500/20 to-transparent rounded-lg border border-gray-800 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-20 h-20"
                  >
                    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </div>
              </div>
              <div className="space-y-8 order-1 md:order-2">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-normal tracking-tight hover:text-blue-400 transition-colors">
                  We value privacy
                </h2>
                <p className="text-gray-400 text-xl hover:text-white transition-colors">
                  Your data is encrypted and never shared
                </p>
                <a
                  href="/privacy_policy.html"
                  className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  Privacy policy
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="ml-2 h-4 w-4"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  )
}